var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"lista-informacoes"},[_c('li',{staticClass:"dropdown-item"},[_c('p',{on:{"click":function($event){return _vm.$emit('click_termos')}}},[_vm._v("Ver termos de uso")])]),_c('li',{staticClass:"dropdown-item"},[_c('p',{on:{"click":_vm.logout}},[_vm._v("Sair do Portal")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }